import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-148079ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["id", "value", "name"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_6 = { class: "tooltiptext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: _ctx.id,
      type: "text",
      value: _ctx.insideText,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:insideText', $event.target.value))),
      name: _ctx.label,
      class: _normalizeClass(["form-control", { invalid: _ctx.invalid }]),
      placeholder: "place",
      tabindex: "1",
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur')))
    }, null, 42, _hoisted_2),
    _createElementVNode("label", {
      for: _ctx.label,
      class: "form-label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_3),
    (_ctx.invalid)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.label,
          class: "form-label-error",
          "data-cy": "login-invalid-label"
        }, [
          _renderSlot(_ctx.$slots, "invalidText", {}, undefined, true)
        ], 8, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.tooltip)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["tooltip", {
        error: _ctx.invalid
      }])
        }, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _renderSlot(_ctx.$slots, "tooltipText", {}, undefined, true)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}